import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { cloneDeep } from 'src/ep-utils';
//import { BaseState } from '../base/base-state'
import { StateHelperService } from '../../../services/proprietary/state-helper.service';
import {
    AddAttachment,
    CloneAttachment,
    DeleteAttachment,
    RestoreAttachment,
    UpdateAttachment,
    UpdateAttachmentDocumentData
} from './attachment.actions';
import { ContractObjectDefaults } from './contract-object.defaults';
import { AddAttachmentPointer, RemoveAttachmentPointer } from './contract.actions';

export interface AttachmentStateModel {
    attachment: any;
    currentID: string;
}

@State<AttachmentStateModel>({
    name: 'contractAttachmentState', //Renamed to resolve name conflict with attachmentState object in CorrespondObjectState.
    defaults: {
        attachment: {},
        currentID: null
    }
})
@Injectable()
export class AttachmentState {
    constructor(private helper: StateHelperService) { }

    //******* SELECTORS *********

    @Selector()
    static fullState(state: AttachmentStateModel) {
        return state.attachment;
    }

    @Selector()
    static currentAttachment(state: AttachmentStateModel) {
        if (state.attachment[state.currentID]) {
            return state.attachment[state.currentID];
        } else {
            return {};
        }
    }

    @Selector()
    static attachments(state: AttachmentStateModel) {
        let result: any = [];
        for (var i in state.attachment) {
            result.push(state.attachment[i]);
        }
        return result;
    }

    @Selector()
    static attachmentCount(state: AttachmentStateModel) {
        let count = 0;
        for (var i in state.attachment) {
            count++;
        }
        return count;
    }

    //******  ACTIONS  ******

    @Action(UpdateAttachment)
    updateAttachment(sc: StateContext<AttachmentStateModel>, action: UpdateAttachment) {
        const state = sc.getState();
        let attachmentID = action.Attachment.Attachment_ID;
        let updateAttachment: any = { ...action.Attachment }; //need DEEP copy?
        this.helper.setItemChanged(updateAttachment, state.attachment[attachmentID].Edit_Status);
        sc.patchState({
            attachment: {
                ...state.attachment,
                [attachmentID]: {
                    ...state.attachment[attachmentID],
                    ...updateAttachment
                }
            }
        });
    }

    @Action(DeleteAttachment)
    deleteAttachment(sc: StateContext<AttachmentStateModel>, action: DeleteAttachment) {
        const state = sc.getState();
        let attachment = { ...state.attachment }; //shallow copy Attachment from state
        this.helper.setItemDeleted(attachment, action.attachmentID);
        sc.patchState({ attachment: attachment });
        if (action.attachmentID < 0) {
            sc.dispatch(new RemoveAttachmentPointer(action.attachmentID.toString()));
        }
    }

    @Action(RestoreAttachment)
    restoreAttachment(sc: StateContext<AttachmentStateModel>, action: RestoreAttachment) {
        const state = sc.getState();
        let attachment = { ...state.attachment }; //shallow copy Attachment from state
        this.helper.setItemRestored(attachment, action.attachmentID);
        sc.patchState({ attachment: attachment });
    }

    @Action(CloneAttachment)
    cloneAttachment(sc: StateContext<AttachmentStateModel>, action: CloneAttachment) {
        const state = sc.getState();
        let srcID = action.attachmentID;
        let newID = this.helper.getTempID();
        let newAttachment = cloneDeep(state.attachment[srcID]);
        this.helper.setItemAdded(newAttachment);
        newAttachment.Attachment_ID = newID;
        sc.patchState({
            currentID: newID,
            attachment: { ...state.attachment, [newID]: newAttachment }
        });
        sc.dispatch(new AddAttachmentPointer(newID));
    }

    @Action(AddAttachment)
    addAttachment(sc: StateContext<AttachmentStateModel>, action: AddAttachment) {
        const state = sc.getState();
        let newID = this.helper.getTempID();
        let newAttachment = this.helper.createDefaultItem(ContractObjectDefaults, 'Contract_Attachment', action.Attachment);
        this.helper.setItemAdded(newAttachment);
        newAttachment.Attachment_ID = newID;
        sc.patchState({
            currentID: newID,
            attachment: { ...state.attachment, [newID]: newAttachment }
        });
        sc.dispatch(new AddAttachmentPointer(newID));
    }

    @Action(UpdateAttachmentDocumentData)
    updateAttachmentDocumentData(sc: StateContext<AttachmentStateModel>, action: UpdateAttachmentDocumentData) {
        const state = sc.getState();
        let attachmentID = action.attachmentID;
        let updateAttachmentDocumentData: any = { ...action.DocumentData }; //need DEEP copy?

        let tempState = cloneDeep(state.attachment[attachmentID]);
        tempState.Document = updateAttachmentDocumentData;

        this.helper.setItemChanged(tempState, state.attachment[attachmentID].Edit_Status);
        sc.patchState({
            attachment: { ...state.attachment, [attachmentID]: tempState }
        });
    }
}
